module.exports = __webpack_public_path__ + "img/branding-logo-tshirt-textiel-huisstijl-full-on-eventsector-2.04315b32.jpg";